(() => {
  const bestSelling = new Set([
    'all', 'tees-polos', 'hoodies-hooded-tops', 'jackets-quarter-zips',
    'hats-beanies', 'desk-gifts', 'bags-travel'
  ]);
  function enhance(root = document) {
    root.querySelectorAll('a[href]').forEach(link => {
      let url;
      try { url = new URL(link.getAttribute('href'), location.href); } catch { return; }
      if (url.origin !== location.origin) return;
      const match = url.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/([^/]+)\/?$/i);
      if (!match) return;
      // Explicit sort choices stay intact. Category tabs are configured in Liquid.
      if (!url.searchParams.has('sort_by')) {
        url.searchParams.set('sort_by', bestSelling.has(match[1]) ? 'best-selling' : 'price-descending');
        link.setAttribute('href', url.pathname + url.search + url.hash);
      }
    });
  }
  enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
